<div class="h-screen w-full flex justify-center items-center font-bold">
  Please scan a QR code to start ordering
</div>
<div class="fixed bottom-8 w-full text-center text-gray-400">heynow</div>

